import { Navigate, Outlet } from "react-router-dom";
import { getHrEmployerSession } from "@/lib/auth/storage";

export function EmployerAuthGuard() {
  if (!getHrEmployerSession()) {
    return <Navigate to="/employer/login" replace />;
  }
  return <Outlet />;
}
